import { roleDetailConstants } from '../../_constants';
import { roleDetailService } from '../../_services';
import { alertActions } from '../alertActions';

export const roleDetailActions = {
    getAccessByMenuSet,
    getAccessByMenuId,
    getAccessByMenu
};

function fetchedRoleDetail() { return { type: roleDetailConstants.ROLE_DETAIL_FETCHED } }
function fetchingRoleDetail() { return { type: roleDetailConstants.ROLE_DETAIL_FETCHING } }

function getAccessByMenu(roleId, menuSet) {
    return dispatch => {
        dispatch(fetchingRoleDetail());

        roleDetailService.getAccessByMenuSet(roleId, menuSet)
            .then(
                roleDetailMenu => {
                    dispatch(fetchedRoleDetail());
                    dispatch(success(roleDetailMenu))
                },
                error => {
                    dispatch(fetchedRoleDetail());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(roleDetailMenu) { return { type: roleDetailConstants.GET_ROLEDETAILMENU, roleDetailMenu } }
}
function getAccessByMenuSet(roleId, menuSet) {
    return dispatch => {
        dispatch(fetchingRoleDetail());

        roleDetailService.getAccessByMenuSet(roleId, menuSet)
            .then(
                roleDetail => {
                    dispatch(fetchedRoleDetail());
                    dispatch(success(roleDetail))
                },
                error => {
                    dispatch(fetchedRoleDetail());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(roleDetail) { return { type: roleDetailConstants.GET_ROLEDETAIL, roleDetail } }
}
function getAccessByMenuId(roleId, menuId) {
    return dispatch => {
        dispatch(fetchingRoleDetail());

        roleDetailService.getAccessByMenuId(roleId, menuId)
            .then(
                roleDetailByMenuId => {
                    dispatch(fetchedRoleDetail());
                    dispatch(success(roleDetailByMenuId))
                },
                error => {
                    dispatch(fetchedRoleDetail());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(roleDetailByMenuId) { return { type: roleDetailConstants.GET_ROLEDETAIL_MENUID, roleDetailByMenuId } }
}

